import { Activity } from "../../components/activity/types";
import { useDashboardStore } from "../../stores";
import {
  CashBuilder,
  CashBuilderBackend,
  CashQuery,
  CashQueryBackend,
  Cash,
  CashUpdater,
  CashUpdaterBackend,
} from "../../types";
import Api from "../api";
import { createFormData, getFileHeaders, parseApiData } from "../utils";

class CashApi extends Api {
  static create(cash: CashBuilder): Promise<void> {
    const headers = getFileHeaders(cash.image);

    return new Promise((resolve, reject) => {
      this.postData<Cash, unknown>(
        "/cash",
        createFormData(this.buildCash(cash)),
        { headers }
      )
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res.activities[0]);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static query(cash: CashQuery): Promise<Array<Cash>> {
    return this.postData(
      "/cash/search",
      parseApiData(this.buildCashQuery(cash))
    );
  }

  static deleteCash(id: string): Promise<void> {
    return new Promise((resolve, reject) => {
      this.deleteData<Activity>(`/cash/${id}`)
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res);
          resolve();
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static update(id: string, cash: CashUpdater): Promise<Cash> {
    const headers = getFileHeaders(cash.image);

    return new Promise((resolve, reject) => {
      this.patchData<Cash, unknown>(
        `/cash/${id}`,
        createFormData(this.buildCashUpdater(cash)),
        { headers }
      )
        .then((res) => {
          useDashboardStore.getState().activitiesAdd(res.activities[0]);
          resolve(res);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  static findCashById(id: string): Promise<Cash> {
    return this.getData(`/cash/${id}`);
  }

  // private
  static buildCash(cash: CashBuilder): CashBuilderBackend {
    return {
      customer: cash.customer?._id.$oid || null,
      description: cash.description,
      image: cash.image?.length ? cash.image[0] : null,
      total_price: cash.total_price,
      type: cash.type?.name || "received",
    };
  }

  static buildCashQuery(cash: CashQuery): CashQueryBackend {
    return {
      customer: cash.customer?._id.$oid || null,
      description: cash.description,
      from: cash.fromDate,
      to: cash.toDate,
      total_price: cash.total_price,
      type: cash.type?.name || null,
    };
  }

  static buildCashUpdater(cash: CashUpdater): CashUpdaterBackend {
    return {
      customer: cash.customer?._id.$oid || null,
      description: cash.description,
      total_price: cash.total_price,
      image: cash.image?.length ? cash.image[0] : null,
    };
  }
}

export default CashApi;
